<template>
  <div class="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark">
    {{ this.$store.state.isLogin }}
    <div
      class="
        d-flex
        flex-column
        align-items-center align-items-sm-start
        px-3
        pt-2
        text-white
        min-vh-100
      "
    >
      <a
        href="/"
        class="
          d-flex
          align-items-center
          pb-3
          mb-md-0
          me-md-auto
          text-white text-decoration-none
        "
      >
        <span class="fs-5 d-none d-sm-inline">Menu</span>
      </a>
      <ul
        class="
          nav nav-pills
          flex-column
          mb-sm-auto mb-0
          align-items-center align-items-sm-start
        "
        id="menu"
      >
        <li class="nav-item">
          <router-link
            :to="{ name: 'Home' }"
            href="#"
            class="nav-link align-middle px-0"
          >
            <i class="fs-4 bi-house"></i>
            <span class="ms-1 d-none d-sm-inline">Home</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'LoginPage' }"
            v-if="!isLogin"
            href="#submenu1"
            data-bs-toggle="collapse"
            class="nav-link px-0 align-middle"
          >
            <!-- <router-link ></router-link> -->
            <i class="fs-4 bi-speedometer2"></i>
            <span class="ms-1 d-none d-sm-inline">Login</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'RegisterPage' }"
            v-if="!isLogin"
            href="#submenu2"
            data-bs-toggle="collapse"
            class="nav-link px-0 align-middle"
          >
            <i class="fs-4 bi-bootstrap"></i>
            <span class="ms-1 d-none d-sm-inline">Register</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'BookmarkPage' }"
            v-if="isLogin"
            href="#"
            class="nav-link px-0 align-middle"
          >
            <i class="fs-4 bi-people"></i>
            <span class="ms-1 d-none d-sm-inline">Bookmark</span>
          </router-link>
        </li>
        <li>
          <a v-if="isLogin" class="nav-link px-0 align-middle">
            <i class="fs-4 bi-people"></i>
            <span class="ms-1 d-none d-sm-inline" @click="loginOut"
              >Signout</span
            >
          </a>
        </li>
      </ul>
      <hr />
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: "Navbar",
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    loginOut() {
      localStorage.clear();
      this.$store.dispatch("logoutUser");
      this.$router.push({ name: "LoginPage" });
      Swal.fire('Thanks for coming!')
    },
  },
};
</script>

<style></style>
